import React from 'react';
import { CloseButton, InnerModal, StyledModal, StyledModalHeader, BlockBackground } from './PopUp.styled';

const PopUp = (props) => (
  <BlockBackground show={props.show}>
    <StyledModal show={props.show} onHide={props.handleClose}>
      <CloseButton onClick={props.handleClose}>
          X
      </CloseButton>
      <InnerModal>
      <StyledModalHeader>
        <p>
          <b>Attention: </b> 
          {props.error ? 
            'There was an error in generating your results. Please adjust your inputs and try again.' :
            'The cost and incentive information presented in this tool is relevant for HOA and condo board members. However, the ROI portion of the tool is currently designed primarily for property managers, owners, and developers.' 
          }
        </p>
      </StyledModalHeader>
      </InnerModal>
    </StyledModal>
   </BlockBackground>
);

PopUp.propTypes = {};

PopUp.defaultProps = {};

export default PopUp;
